import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APQRCode.css';
var APQRCode = function APQRCode(props) {
  var value = props.value,
    customClass = props.customClass,
    size = props.size;
  var baseClass = 'qr-code';
  var bemClasses = getBEMClasses(baseClass, customClass);
  return React.createElement(QRCode, {
    value: value,
    size: size,
    className: bemClasses()
  });
};
APQRCode.defaultProps = {
  size: 280,
  customClass: ''
};
APQRCode.protoTypes = {
  size: PropTypes.number,
  customClass: PropTypes.string,
  value: PropTypes.string.isRequired
};
export default APQRCode;